import React from "react"
import withStyles from "react-jss"

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    textAlign: "center",
    width: "100%",
    height: "100vh",
  },
  text: {
    margin: "-3rem 0 0 0",
    textAlign: "center",
  },
}

const Fallback = ({ classes }) => {
  return (
    <div className={classes.container}>
      <p className={classes.text}>Something went wrong, please reload!</p>
    </div>
  )
}

export default withStyles(styles)(Fallback)
